module.exports = __webpack_public_path__ + "img/constructionerror.9e4dfab6.png";